import { resetRouter } from '@/router/index.js'
import {login,loginOut} from '@/api/base.js'
export default{
    state:{
        token: null,
        userInfo: null,
		programData:{}
    },
    mutations:{
        setToken(state,value){
            state.token = value
        },
        setUserInfo(state,value){
            state.userInfo = value
        },
    },
    actions:{
        userLogin(context,params){
            return new Promise((resolve, reject) => {
                login(params).then(res=>{
                    console.log(res,'red')
                    if(res.data.value.token){
                        res.data.value.user = {
                            ...res.data.value.user,
                            mobile: res.data.value.mobile,
                            supUserId: res.data.value.supUserId,
                        }
                        context.commit('setToken',res.data.value.token)
                        context.commit('setUserInfo',res.data.value.user)
                        // if(!res.data.data.user.roleId){
                        //     resolve({
                        //         message: '当前账户未分配角色，请联系管理员！'
                        //     })
                        // }else{
                            resolve({
                                code: 200,
                                value: res.data.value
                            })
                        // }
                    }
                }).catch(err=>{
                    reject(err)
                })
            })
        },
        userExist(context,params){
            return new Promise((resolve, reject) => {
                loginOut(params).then(res => {
                    context.commit('setToken', null)
                    context.commit('setUserInfo', null)
                    context.commit('setMenuList', null)
                    context.commit('setHandleMenu', null)
                    context.commit('setMenuFirstInfo', null)
                    context.commit('setMenuActive', null)
                    context.commit('setMenuTopList', null)
                    context.commit('setMenuSliderActive', null)
                    context.commit('setNotice', null)
                    context.commit('SET_DICT', null)
                    sessionStorage.clear()
                    resetRouter()
                    resolve()
                  }).catch(err => {
                    reject(err)
                  })
            })
        },
    }
}